<template>
  <div class="download" :style="{ backgroundImage: 'url(' + bgImg + ')' }">
    <div class="content">
      <div class="title">
        <div class="titleIcon">
          <img src="@/assets/download/icon-immers@2x.png" alt="" />
        </div>
        <div class="titleText">Immers</div>
      </div>
      <div class="phone">
        <img src="@/assets/download/iPhone@3x.png" alt="" />
      </div>

      <div class="button" v-if="!apple" @click="opanApp">
        <div class="button-img">
          <img src="@/assets/download/icon-and3x.png" alt="" />
        </div>
        <span>Android下载</span>
      </div>
      <div class="button" v-if="apple" @click="opanApp">
        <div class="button-img">
          <img src="@/assets/download/icon-ios3x.png" alt="" />
        </div>
        <span>Apple下载</span>
      </div>
    </div>
    <!-- 微信提示背景图 -->
    <van-overlay :show="wxFlag">
      <div v-if="wxFlag" class="wx">
        <img src="@/assets/download/wxOpen.png" alt="" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import bgImg from "@/assets/download/bgd3x.png";
import { Dialog } from "vant";
// import CallApp from "callapp-lib";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      bgImg: bgImg,
      apple: true, //判断是否ios设备
      wxFlag: true,
      //配置参数
      // option: {
      //   scheme: {
      //     protocol: "immers", //ios打开协议
      //     host: "", //
      //     port: "",
      //   },
      //   appstore: "https://apps.apple.com/cn/app/id1631264709", //下载地址
      //   fallback: "http://immers.download.smartsuperv.com", //唤端失败后跳转的地址-跳转会下载页
      //   timeout: 5500, //
      // },
    };
  },

  methods: {
    // 判断是ios还是安卓
    judge() {
      //ios
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        this.apple = true;
        // setTimeout(() => {
        //   if (!this.wxFlag) {
        //     window.location.href = "immers://"; //ios打开协议
        //   }
        // }, 500);
        this.$Axios
          .get("immers://")
          .then((res) => {
            // console.log(res)
            if (res.status == 200) {
              window.location.href = "immers://"; //ios打开协议
            }
          })
          .catch(error => { })
      }
      //安卓
      else if (navigator.userAgent.match(/android/i)) {
        this.apple = false;
        setTimeout(() => {
          if (!this.wxFlag) {
            window.location.href = "immers://splash/?arg0=zkd&arg1=test"; //安卓打开协议
          }
        }, 500);
      }
    },
    //下载app
    opanApp() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        // window.location.href = "immers://"; //ios打开协议
        // window.setTimeout(function () {
        window.location.href = "https://apps.apple.com/cn/app/id1631264709";
        // }, 2000);
        // const callLib = new CallApp(this.option);
        // callLib.open({
        //   path: "",
        // });


      } else if (navigator.userAgent.match(/android/i)) {
        let data = {
          systemType: 0, //1是ios, 0是安卓
        };
        // window.location.href = "immers://splash"; //安卓打开协议
        this.$Axios
          .post(this.$Api.appVersionGetDownloadApp, data)
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data.data != "") {
                window.location.href = res.data.data.apkUrl; //安卓下载地址
                // this.option.fallback = res.data.data.apkUrl;
                // // this.option.scheme.host = 'splash/'
                // const callLib = new CallApp(this.option);
                // callLib.open({
                //   path: "splash/",
                //   param: {
                //     arg0: "zkd",
                //     arg1: "test",
                //   },
                // });
              }
            }
          })
          .catch((err) => { });
      }
    },
  },
  created() {
    var ua = window.navigator.userAgent.toLowerCase();
    //微信打开提示去浏览器
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.wxFlag = true;
    } else {
      this.wxFlag = false;
    }
    //一进入就判断是安卓还是ios
    this.judge();
  },
};
</script>

<style lang="less" scoped>
// scoped：只让样式在当前页面中起作用，不会作用到它的子组件中
.download {
  height: 1624px;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .content {
    text-align: center;

    .title {
      display: flex;
      justify-content: center;
      align-items: center;

      .titleIcon {
        width: 88px;
        height: 88px;
        margin-top: 123px;
        border-radius: 14px 14px 14px 14px;
        background: rgba(255, 255, 255, 0.34) linear-gradient(180deg, #ffffff 0%, rgba(0, 0, 0, 0) 100%);
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 81px;
          height: 81px;
        }
      }

      .titleText {
        width: 301px;
        height: 112px;
        font-size: 82px;
        font-family: Open Sans-Medium, Open Sans;
        font-weight: 500;
        color: #ffffff;
        line-height: 120px;
        margin-left: 66px;
        margin-top: 111px;
        margin-right: 30px;
      }
    }

    .phone {
      width: 499.11px;
      margin: auto;
      margin-top: 81px;
      margin-bottom: 73px;

      img {
        width: 100%;
      }
    }

    .button {
      width: 498px;
      height: 98px;
      background: #343434;
      box-shadow: 0px 16px 10px 1px rgba(0, 0, 0, 0.1),
        -10px 23px 25px 1px rgba(0, 0, 0, 0.73);
      border-radius: 15px 15px 15px 15px;
      opacity: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;

      .button-img {
        width: 48px;
        height: 48px;
        color: #fff;
        display: flex;

        margin-right: 40px;

        img {
          width: 48px;
          height: 48px;
        }
      }

      span {
        font-size: 40px;
        font-weight: 400;
        color: #ffffff;
        line-height: 53px;
        letter-spacing: 3px; //字体间隔
      }
    }
  }

  .wx {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
    }
  }
}
</style>
